"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getAllAvailableSTartTimes;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _TimeRangeListUtils = require("MeetingsBase/utils/TimeRangeListUtils");

var _enums = require("MeetingsBase/constants/enums");

var _dates = require("MeetingsBase/constants/dates");

function getAllAvailableSTartTimes(availableTimePeriods, durations, startTimeIncrementMinutes, userTimezone) {
  return durations.reduce(function (allAvailableStartTimes, duration) {
    var startTimeMinuteValue = _enums.START_TIME_INTERVAL_VALUES[startTimeIncrementMinutes];
    var startTimeIntervalMilliseconds = startTimeMinuteValue === _enums.START_TIME_INTERVALS.MEETING_DURATION ? duration : startTimeMinuteValue * _dates.MINUTES_TO_MILLIS;
    var startTimes = (0, _TimeRangeListUtils.getFlexibleIntervalStartTimes)(availableTimePeriods, duration, startTimeIntervalMilliseconds);
    var groupedAvailableTimes = startTimes.groupBy(function (startTimestamp) {
      return _I18n.default.moment(startTimestamp).tz(userTimezone).format('YYYY-MM-DD');
    });
    return allAvailableStartTimes.set(duration, groupedAvailableTimes);
  }, (0, _immutable.OrderedMap)());
}

module.exports = exports.default;